import { OLA_MAPS_AUTOCOMPLETE_API_KEY } from '../constants/OlaMapsAutocompleteConstants'

export const getOlaMapSearchUrl = (
   lat: number,
   lng: number,
   radius: number,
   searchText: string | undefined
) =>
   `https://api.olamaps.io/places/v1/autocomplete?location=${lat},${lng}&radius=${radius}&strictbounds=true&input=${searchText}&api_key=${OLA_MAPS_AUTOCOMPLETE_API_KEY}`
